export default __webpack_public_path__ + "static/bg_pgslot-4404cf296354d77a5582de7e21408c11.png";